<div class="layout small-gap">
    <div class="section-header no-border layout_one_up_center">
      Welcome, {{ displayName }}
    </div>
    <div class="layout_one_up_center">
      <div class="announcement-content-body">
        <b>Note:</b> The USAN application deadline for the <b>December 2026</b> USAN Council meeting is <b>October 23, 2026</b>. Following review at the USAN Council meeting, most applicants can expect a response from the USAN Council before the deadline for the spring INN consultation.
      </div>
    </div>
    <div class="layout_one_up_center">
        <div class="text-content text-content-body">
          <b>Application Instructions</b>
        </div>
        <span class="text-content text-content-body">
          Welcome to the USAN Application Portal. This platform simplifies the process of applying for United States Adopted Names (USAN) for pharmaceutical compounds. As a USAN user, you can review, add comments, upload documents, add payments and receive notifications on applications for which you have been granted access by your organization's administrator.
        </span>
    </div>
    <div class="flexbox layout_one_up_center">
        <app-user-applications-list ></app-user-applications-list>
    </div>
</div>
  
